import React from 'react';

export default class PlayerBotStatsCard extends React.Component
{
  render()
  {
    const { title, value, type, icon, loading } = this.props;

    return (
      <div className={ `stats-card stats-card-${type}` }>
        <div className="stats-card-header">
          <span className="stats-card-icon">{ icon }</span>
          <span className="stats-card-title">{ title }</span>
        </div>
        <div className="stats-card-value">
          { loading ? (
            <div className="stats-card-loading">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <span className="stats-value-number">{ value }</span>
          ) }
        </div>
      </div>
    );
  }
}
